import script from "./goRinSyo0063.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0063.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0063.vue?vue&type=style&index=0&id=b00ab6c2&lang=scss"

const __exports__ = script;

export default __exports__